import React from 'react';
import { useNavigate } from 'react-router-dom';

const LatestPosts = ({ allblog }) => {
    const navigate = useNavigate();

    const handleDetailsRow = (id) => {
        navigate(`/blog/${id}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="space-y-4">
            {allblog.slice(0, 3).map((row, index) => (
                <div
                    key={index}
                    onClick={() => handleDetailsRow(row.id)}
                    className="flex gap-4 items-start cursor-pointer p-3 rounded-lg border border-gray-200 bg-white hover:shadow-md transition duration-300"
                >
                    <div className="w-24 h-24 flex-shrink-0 overflow-hidden rounded-lg">
                        <img
                            src={row.image}
                            alt={row.title}
                            className="object-cover w-full h-full hover:scale-105 transition-transform duration-300"
                        />
                    </div>
                    <div className="flex-1">
                        <h3 className="text-md font-semibold text-[#036642] mb-1">{row.title}</h3>
                        <p className="text-xs text-gray-500">{row.date}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default LatestPosts;
